import './GetInfo.scss';
import Component from './GetInfo.js';
export default Component;
